import React from 'react'

const EmptyState = ({image}) => {
    return (
        <div className="text-center">
            <img
                src={image}
                alt="empty tip goal list"
                style={{height: "125px", width: "150px"}}
                className="mt-4 mb-2"
            />
            <p className="emptyTipListText">
                Looks like you didn’t get any likes yet, keep Promoting…
            </p>
        </div>
    )
}

export default EmptyState;
